import styled from 'styled-components';

export const Container = styled.div`
  background: #f4f0ec;

  h1 {
    color: #ff6900;
    font-family: 'Poppins';
    font-size: 26px;
    font-weight: 500;
    line-height: 108%;
  }

  h2 {
    color: #002f6c;
    font-weight: 700 !important;
    line-height: 29px !important;
  }

  canvas {
    border-radius: 30px;
  }

  .share {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 2;
  }

  .line-lower-left,
  .line-upper-left,
  .line-upper-right {
    position: absolute;
    z-index: 1;
  }

  .line-upper-left {
    top: 0;
    left: 0;
    border-right: 4px solid #ff6900;
    border-bottom: 4px solid #ff6900;
    border-bottom-right-radius: 25px;
    height: 30px;
    width: 60%;
  }

  .line-upper-right {
    top: 0;
    right: 0;
    border-left: 4px solid #ff6900;
    border-bottom: 4px solid #ff6900;
    border-bottom-left-radius: 25px;
    height: 80px;
    width: 20%;
  }

  .line-lower-left {
    bottom: 0;
    left: 0;
    border-right: 4px solid #ff6900;
    border-top: 4px solid #ff6900;
    border-top-right-radius: 25px;
    height: 50px;
    width: 60%;
  }

  .bd-qrcode {
    border-radius: 30px;
    border: 10px solid #ff6900;
    padding-bottom: 30px;
    //padding: 36px;
    //background-color: #fff;
  }

  .bg-qr-orange {
    position: absolute;
    background: #ff6900;
    height: 150px;
    width: 100%;
    top: 200px;
    z-index: 1;
  }

  .index {
    z-index: 2;
    position: relative;
  }

  .data {
    color: #002f6c;
    font-size: 14px;
    font-weight: 400;
    span {
      color: #002f6c;
      font-weight: 600;
    }
  }

  .my-ticket {
    color: #fff;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 400;

    border-radius: 4px;
    background: #00a3e0;
    min-width: 103px;
  }

  .event p {
    color: #8c8c8c;
    font-size: 14px;
    font-weight: 400;
  }

  .bg-white {
    border-radius: 8px;
  }

  .circle-left {
    width: 10px;
    height: 20px;
    margin-left: -2px;
    //border-radius: 50px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;

    border-bottom: 2px solid #dfdfdf;
    border-top: 2px solid #dfdfdf;
    border-right: 2px solid #dfdfdf;
    background: #f4f0ec;
  }

  .circle-right {
    width: 10px;
    height: 20px;
    margin-right: -2px;
    //border-radius: 50px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top: 2px solid #dfdfdf;
    border-bottom: 2px solid #dfdfdf;
    border-left: 2px solid #dfdfdf;
    background: #f4f0ec;
  }

  .small-circle {
    border: 1px solid #dfdfdf;
    width: 6px;
    height: 6px;
    background: #f4f0ec;
    border-radius: 10px;
  }
  .bg-ticket {
    border-radius: 25px;
    border: 4px solid #ff6900;

    background: #fff;

    img {
      width: 150px;
      height: 150px;
    }

    p {
      color: #002f6c;
      font-size: 14px;
      font-weight: 400;
      span {
        color: #002f6c;
        font-weight: 600;
      }
    }

    .ident {
      color: #002f6c;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 13px;
      border-radius: 8px;
      //border: 1px solid #002f6c;
      position: absolute;
      bottom: 32px;
      left: 90px;
    }
  }
`;

export const BtnRevealQrCode = styled.button`
  position: relative;

  .blur {
    position: absolute;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(4px);
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: 0.3s;
    opacity: 0;
    visibility: hidden;

    svg {
      path {
        fill: #fff !important;
      }
    }
  }
`;
